// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".where-body[data-v-240dc323]{padding:1rem .5rem}.animated-map[data-v-240dc323]{height:100%;left:0;position:fixed!important;top:0;width:100%}.body-content[data-v-240dc323]{margin:50vh auto 0;max-width:1280px;padding:0 1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
